import React from 'react';
import { TextArea } from 'antd-mobile';
import s from '../style.module.scss';

// 开放文本题（H5 版）：非必填，maxLength 原生截断（满 50 字后无法继续输入）
// 字数统计展示在输入框内右下角（showCount 自定义渲染，满格时数量数字标红），整体高度 104px（见样式 .text-area）
const TextQuestionRow = (props) => {
    const { question, value = '', onChange } = props,
        { code, title, placeholder, maxLength = 50 } = question,
        text = value || '';

    return (
        <div className={s['question-row']}>
            {title ? (
                <div className={s['question-title-wrap']}>
                    <span className={s['question-title']}>{title}</span>
                </div>
            ) : null}
            <div className={s['text-area-wrap']}>
                <TextArea
                    className={s['text-area']}
                    value={text}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    showCount={(length, countMaxLength) => (
                        <div className={s['text-count']}>
                            <span className={length >= countMaxLength ? s['count-full'] : ''}>{length}</span>/{countMaxLength}
                        </div>
                    )}
                    onChange={(val) => onChange(code, val)}
                />
            </div>
        </div>
    );
};

export default TextQuestionRow;
